import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
import { productShots } from '../data/ecosystem';
const groups = [{
  tone: INK.blue,
  name: 'Source',
  items: 'Deal sourcing · Raiseboards · Lookbooks'
}, {
  tone: INK.violet,
  name: 'Understand',
  items: 'Company profiles · Research'
}, {
  tone: INK.gold,
  name: 'Evaluate',
  items: 'Diligence · Scoring'
}, {
  tone: INK.emerald,
  name: 'Communicate',
  items: 'Investment memos · Reporting'
}];
export function ProductExperienceSlide() {
  return <Slide data-id="element-488" data-mp="20cfnkcrk3mol">
      <div className="max-w-[70%]" data-id="element-489" data-mp="20cyy38evn8sl">
        <Eyebrow data-id="element-490" data-mp="20bxlgzi7qe8r">The product</Eyebrow>
        <Title className="mt-[2.2cqh]" data-id="element-491" data-mp="20ea47evsosmv">The DiligenceGPT™ platform, in production today.</Title>
      </div>

      <div className="mt-[3cqh] grid min-h-0 flex-1 grid-cols-[72%_1fr] gap-[2.4cqw]" data-id="element-492" data-mp="2aamus3w1mqde">
        <Reveal delay={0.1} className="flex min-h-0 items-start" data-id="element-493" data-mp="2a88xdodw522o">
          <img src={productShots.dealAnalysis} alt="DiligenceGPT deal analysis workspace showing deal fit score, gap analysis, market intelligence and business risk reports" className="max-h-full w-full border border-white/12 object-contain object-top" data-id="element-494" data-mp="25d3hb6766hmi" />
        </Reveal>

        <div className="flex min-h-0 flex-col justify-between" data-id="element-495" data-mp="2wjsy1e5miyl7">
          {groups.map((g, i) => <Reveal key={g.name} delay={0.12 + i * 0.07} data-id="element-496" data-mp="31eos0juf7w0y" data-mpi={i}>
              <div className="flex items-center gap-[0.7cqw]" data-id="element-497" data-mp="36etb8hmpr4uv">
                <span className="h-[0.9cqh] w-[0.9cqh] rounded-full" style={{
              background: g.tone
            }} data-id="element-498" data-mp="3bepe2djocq8u" />
                <span className="text-[clamp(8px,0.84cqw,17px)] uppercase tracking-[0.22em]" style={{
              color: g.tone
            }} data-id="element-499" data-mp="3g67e8zdvimsr">
                  {g.name}
                </span>
              </div>
              <Caption className="mt-[0.9cqh]" data-id="element-500" data-mp="3u5gm9brxealn">{g.items}</Caption>
            </Reveal>)}
        </div>
      </div>
    </Slide>;
}